import React from 'react';

const HutCard = ({ group, onClick, actionLabel, onAction, actionDisabled }) => {
    const handleAction = (e) => {
        e.stopPropagation();
        if (onAction && !actionDisabled) {
            onAction(group);
        }
    };

    return (
        <div
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow cursor-pointer flex flex-col justify-between h-full"
            onClick={() => onClick && onClick(group)}
        >
            <div>
                <div className="flex justify-between items-start mb-2">
                    <h3 className="text-xl font-semibold text-gray-800 line-clamp-1" title={group.name}>{group.name}</h3>
                    {group.userRole && (
                        <span className={`text-xs px-2 py-1 rounded-full ${group.userRole === 'admin' ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800'
                            }`}>
                            {group.userRole}
                        </span>
                    )}
                    {!group.userRole && actionLabel && (
                        <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">Open</span>
                    )}
                </div>

                <p className="text-gray-600 mb-4 line-clamp-2" title={group.description}>
                    {group.description || 'No description provided.'}
                </p>

                <div className="text-sm text-gray-500 space-y-1 mb-4">
                    <div className="flex items-center gap-2">
                        <span>📍</span>
                        <span className="truncate">
                            {group.location || 'TBD'}
                            {group.distance !== null && group.distance !== undefined && (
                                <span className="ml-2 text-indigo-600 font-medium text-xs">
                                    ({group.distance.toFixed(1)} mi)
                                </span>
                            )}
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span>📅</span>
                        <span>
                            {group.date ? new Date(group.date).toLocaleDateString() : 'No date'}
                            {group.time ? ` @ ${group.time}` : ''}
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span>👥</span>
                        <div className="flex items-center gap-1" title={`${group.spotsTaken || 0} / ${group.maxPlayers || 4} players`}>
                            {Array.from({ length: group.maxPlayers || 4 }).map((_, i) => (
                                <div
                                    key={i}
                                    className={`w-3 h-3 rounded-full ${i < (group.spotsTaken || 0) ? 'bg-indigo-600' : 'bg-gray-200 border border-gray-300'}`}
                                />
                            ))}
                            <span className="ml-2 text-xs text-gray-500">
                                {group.spotsTaken || 0}/{group.maxPlayers || 4}
                            </span>
                        </div>
                    </div>
                    {(group.minPti !== undefined || group.maxPti !== undefined) && (
                        <div className="flex items-center gap-2">
                            <span>📊</span>
                            <span>PTI: {group.minPti ?? 0} - {group.maxPti ?? 0}</span>
                        </div>
                    )}
                </div>
            </div>

            {actionLabel && (
                <button
                    onClick={handleAction}
                    disabled={actionDisabled}
                    className={`w-full py-2 rounded-lg transition-colors mt-auto ${actionDisabled
                        ? 'bg-gray-300 cursor-not-allowed text-gray-500'
                        : 'bg-indigo-600 text-white hover:bg-indigo-700'
                        }`}
                >
                    {actionLabel}
                </button>
            )}
        </div>
    );
};

export default HutCard;
